import { __rest, __assign } from 'tslib';
import React from 'react';
import { useIsDesktop } from '../../mq/esm';
import { ConfirmationDesktop } from './desktop/component.desktop.js';
import { ConfirmationMobile } from './mobile/component.mobile.js';
import './components/base-confirmation/component.js';
import 'classnames';
import '@alfalab/hooks';
import './context.js';
import './utils.js';
import './types.js';
import './components/screens/initial/component.js';
import '../../button/esm/mobile';
import '../../code-input/esm/desktop';
import '../../code-input/esm/mobile';
import '../../link/esm';
import '../../typography/esm';
import './components/header/component.js';
import './countdown-section-7e1d30f1.js';
import '../../button/esm';
import '../../spinner/esm';
import './components/screens/hint/component.js';
import './components/screens/fatal-error/component.js';
import './components/screens/temp-block/component.js';
import './components/countdown-loader/component.js';

var ConfirmationResponsive = function (_a) {
    var breakpoint = _a.breakpoint, client = _a.client, _b = _a.defaultMatchMediaValue, defaultMatchMediaValue = _b === void 0 ? client === undefined ? undefined : client === 'desktop' : _b, restProps = __rest(_a, ["breakpoint", "client", "defaultMatchMediaValue"]);
    var isDesktop = useIsDesktop(breakpoint, defaultMatchMediaValue);
    return isDesktop ? (React.createElement(ConfirmationDesktop, __assign({}, restProps))) : (React.createElement(ConfirmationMobile, __assign({ breakpoint: breakpoint }, restProps)));
};

export { ConfirmationResponsive };
